import React from "react";

// Page One-styled paywall gate. Self-contained inline styles so it renders
// correctly both inside the newsprint front page (.bi-p1) and in the tab views.
// The CTA dispatches the global `bi:subscribe` event, which the app routes to
// checkout (signed in) or to login first (signed out).

const C = { paper: "#F2EFE9", ink: "#232526", faded: "#5A5D60", steel: "#5E7E92", ochre: "#C8963E" };
const HEAD = "'Oswald','Helvetica Neue',Arial,sans-serif";
const BODY = "'Lora',Georgia,serif";

const subscribe = () => window.dispatchEvent(new CustomEvent("bi:subscribe"));

export default function PaywallGate({
  eyebrow = "Members only",
  heading = "Go deeper with a membership",
  blurb = "The full assessment — probabilities, sourcing, and second-order effects — is available to members. The daily brief and podcast are always free.",
  cta = "Unlock with a membership",
}) {
  return (
    <div style={{
      maxWidth: 620, margin: "24px auto", padding: "30px 26px", textAlign: "center",
      background: C.paper, border: `1px solid ${C.ink}`,
      boxShadow: "0 1px 0 rgba(35,37,38,0.06)",
    }}>
      {/* Steel atomic starburst */}
      <svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true" style={{ display: "block", margin: "0 auto 10px" }}>
        <path d="M12 0 L13.8 10.2 L24 12 L13.8 13.8 L12 24 L10.2 13.8 L0 12 L10.2 10.2 Z" fill={C.steel} />
      </svg>
      <div style={{ fontFamily: HEAD, textTransform: "uppercase", letterSpacing: "0.2em", fontSize: 11, color: C.ochre, marginBottom: 8 }}>
        {eyebrow}
      </div>
      <h3 style={{ fontFamily: HEAD, textTransform: "uppercase", letterSpacing: "0.02em", fontWeight: 700, fontSize: 24, color: C.ink, margin: "0 0 10px" }}>
        {heading}
      </h3>
      <p style={{ fontFamily: BODY, fontSize: 15.5, lineHeight: 1.55, color: C.ink, margin: "0 auto 18px", maxWidth: 500 }}>
        {blurb}
      </p>
      <button
        onClick={subscribe}
        style={{
          fontFamily: HEAD, textTransform: "uppercase", letterSpacing: "0.12em", fontSize: 13,
          color: C.paper, background: C.ink, border: "none", padding: "13px 26px", cursor: "pointer",
        }}>
        {cta}
      </button>
      <div style={{ fontFamily: HEAD, textTransform: "uppercase", letterSpacing: "0.08em", fontSize: 11, color: C.faded, marginTop: 14 }}>
        Already a member?{" "}
        <button onClick={subscribe} style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: C.steel, font: "inherit", textDecoration: "underline", textUnderlineOffset: 2 }}>
          Sign in
        </button>
      </div>
    </div>
  );
}
